import { Component, OnInit } from '@angular/core';

import { distinctUntilChanged, map } from 'rxjs/operators';

import GuideFacade from '@app/core/facades/guide.facade';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '198px';

@Component({
  selector: 'app-filter-guide',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class GuidesFilterComponent extends FilterComponent implements OnInit {
  public readonly width = SIZE;
  public readonly label = 'Guides';

  constructor(private readonly _data: GuideFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateSelectedGuidePerLevelId(value);
    this.valueChange.emit(new FilterChange(FilterType.GuidesPerLevel, value));
  }

  ngOnInit() {
    this.options$ = (
      !!this.config.transform ? this.config.transform(this._data.guidesPerLevel$) : this._data.guidesPerLevel$
    ).pipe(
      distinctUntilChanged(),
      map((options: Array<{ [key: string]: string }>) =>
        options.map((option) => ({ label: `${option.fullName}`, value: option.id }))
      )
    );

    this.initDefaultValues(this._data.selectedGuidePerLevelId$);
  }
}
